import { jsx } from "react/jsx-runtime";
import {
  createContext,
  useContext
} from "react";
const FilterWizardContext = createContext(
  null
);
const FilterWizardProvider = ({
  wizardState,
  children
}) => /* @__PURE__ */ jsx(FilterWizardContext.Provider, { value: wizardState, children });
const useFilterWizardContext = () => {
  const context = useContext(FilterWizardContext);
  if (!context) {
    throw new Error(
      "FilterWizard must be wrapped with FilterWizardProvider. Make sure to wrap your FilterWizard component with FilterWizardProvider and pass the wizard state from useFilterWizard hook. Example: <FilterWizardProvider value={wizardState}><FilterWizard>...</FilterWizard></FilterWizardProvider>"
    );
  }
  return context;
};
export {
  FilterWizardProvider,
  useFilterWizardContext
};
